import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator de senha forte.
 * Retorna erros individuais para cada requisito nao cumprido:
 *   - minLength: senha possui menos de 8 caracteres
 *   - maiuscula: ausencia de letra maiuscula
 *   - numero:    ausencia de digito numerico
 *   - especial:  ausencia de caractere especial
 *
 * Retorna null quando todos os requisitos sao satisfeitos.
 */
export function senhaForteValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';

    if (!value) {
      return null; // campo vazio: deixa o Validators.required tratar
    }

    const errors: ValidationErrors = {};

    if (value.length < 8) {
      errors['minLength'] = true;
    }

    if (!/[A-Z]/.test(value)) {
      errors['maiuscula'] = true;
    }

    if (!/[0-9]/.test(value)) {
      errors['numero'] = true;
    }

    if (!/[^A-Za-z0-9]/.test(value)) {
      errors['especial'] = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };
}
